import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/union.png';
import _imports_1 from '@/assets/icon/arr_ic.png';
import _imports_2 from '@/assets/icon/tick.png';
import _imports_3 from '@/assets/icon/edit.png';
const _withScopeId = n => (_pushScopeId("data-v-fe0c19ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "invoicePage" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "invoiceContent" };
const _hoisted_4 = { class: "orderInfo" };
const _hoisted_5 = { class: "orderNum" };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 订单编号");
const _hoisted_7 = { class: "numberDetail" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "copyText" }, "复制", -1));
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "numberDetail" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "copyText" }, "复制", -1));
const _hoisted_12 = { class: "orderAmount flex-align-center" };
const _hoisted_13 = /*#__PURE__*/ _createTextVNode(" 订单金额");
const _hoisted_14 = { class: "amountDetail" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "selectTab" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "invoiceTips" }, " 电子发票与纸质发票具备同等法律效力，可支持报销入账 ", -1));
const _hoisted_19 = { class: "electronicBox" };
const _hoisted_20 = ["onSubmit"];
const _hoisted_21 = { class: "flex-align-center invoiceList" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, [
    /*#__PURE__*/ _createTextVNode("发票类型"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_23 = ["onClick"];
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, [
    /*#__PURE__*/ _createTextVNode("发票内容"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_26 = { class: "contentText flex-align-center" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_28 = {
    key: 0,
    class: "invoiceList flex"
};
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, [
    /*#__PURE__*/ _createTextVNode("抬头类型"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_30 = { class: "selectRadio flex-align-center" };
const _hoisted_31 = /*#__PURE__*/ _createTextVNode(" 个人 ");
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_33 = [
    _hoisted_32
];
const _hoisted_34 = /*#__PURE__*/ _createTextVNode(" 企业 ");
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_36 = [
    _hoisted_35
];
const _hoisted_37 = { class: "invoiceList" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, [
    /*#__PURE__*/ _createTextVNode("发票抬头"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_39 = {
    key: 1,
    class: "invoiceList"
};
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "bank" }, [
    /*#__PURE__*/ _createTextVNode("税号"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_41 = {
    key: 2,
    class: "invoiceList"
};
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "电子邮箱", -1));
const _hoisted_43 = { class: "invoiceList" };
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "bank" }, "开户银行", -1));
const _hoisted_45 = { class: "invoiceList" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "bank" }, "银行账号", -1));
const _hoisted_47 = { class: "invoiceList" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "address" }, "注册地址", -1));
const _hoisted_49 = { class: "invoiceList" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "address" }, "注册电话", -1));
const _hoisted_51 = {
    key: 0,
    class: "paperBox"
};
const _hoisted_52 = { class: "invoiceList flex-align-center" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "address" }, [
    /*#__PURE__*/ _createTextVNode("收票地址"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_54 = { class: "contentText flex-align-center" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { "color": "#949699" } }, "去添加", -1));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_57 = ["onClick"];
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "submitInput",
    type: "submit"
}, "提交", -1));
const _hoisted_59 = [
    _hoisted_58
];
const _hoisted_60 = { class: "instructionsBox" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "instructionsTitle" }, "开票金额说明", -1));
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "instructionsText" }, " 1、开票金额为消费者实付金额，优惠券、购物券、不在开票范围内； ", -1));
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "instructionsText" }, " 2、如订单发生退货退款，开票金额将变为最终实付金额 ", -1));
const _hoisted_64 = { class: "typeList" };
const _hoisted_65 = ["onClick"];
const _hoisted_66 = { class: "marginL-20 invoiceName" };
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_68 = [
    _hoisted_67
];
const _hoisted_69 = { class: "typeList" };
const _hoisted_70 = ["onClick"];
const _hoisted_71 = { class: "marginL-20" };
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_73 = [
    _hoisted_72
];
const _hoisted_74 = { class: "typeList" };
const _hoisted_75 = ["onClick"];
const _hoisted_76 = { class: "companyName flex-align-center" };
const _hoisted_77 = { class: "default" };
const _hoisted_78 = { class: "marginL-20" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "editImg" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_3 })
], -1));
const _hoisted_80 = {
    key: 0,
    class: "bottomBtn"
};
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "submitInput",
    type: "submit"
}, "添加新的抬头", -1));
const _hoisted_82 = {
    key: 1,
    class: "submitInput",
    style: { "background": "#afafb3" }
};
import { hostPath } from '@/public/utils/basePath';
import { isLogin, userLogin } from '@/widget/index';
import { isCompanyNo, isEmail, isBankCard } from '@/widget/validate';
import { useRoute } from 'vue-router';
import { getInvoiceContent, getInvoiceList, applyInvoice, templateDetail, detailByUserId, orderDetail } from '@/api/invoice';
import BottomDialog from './components/bottomDialog.vue';
import Header from '@/components/common/Header.vue';
import { appPort, closeWebView, hiddenAppNavBar } from '@/widget/index';
import { onMounted, ref, reactive, getCurrentInstance } from 'vue';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const isApp = ref(appPort());
        const isElectronicInvoice = ref(true);
        const showDescription = ref(false);
        const showModal = ref(false);
        const showContent = ref(false);
        const showInfo = ref(false);
        // 1:电子发票, 2:纸质发票
        const nowInvoiceType = ref(1);
        const contentId = ref(1);
        const nowInvoiceName = ref('普通发票');
        const contentName = ref('');
        const contentRef = ref('');
        const invoiceContent = ref([]);
        const invoiceList = ref([]);
        const listTotal = ref(0);
        const route = useRoute();
        const orderData = ref({});
        const orderType = String(route.query.type || 'MEETING').toUpperCase();
        const orderId = route.params.orderId;
        const orderIds = String(route.query.orderIds || '');
        const orderList = ref([]);
        const invoiceTypeVal = [
            {
                type: 1,
                invoiceName: '增值税专用发票'
            },
            {
                type: 2,
                invoiceName: '普通发票'
            }
        ];
        const formData = reactive({
            moduleType: orderType,
            electronicInvoice: 1,
            invoiceType: 2,
            contentType: '',
            invoiceTypePersonalCompany: 1,
            invoiceTitle: '',
            invoiceCode: '',
            invoiceEmail: '',
            companyBank: '',
            companyBankNo: '',
            companyAddr: '',
            companyPhone: '',
            templateId: '0',
            addressId: '',
            isDefault: false
        });
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        /* 获取发票内容数据 */
        const getContent = () => {
            getInvoiceContent({
                page: 1,
                moduleType: String(formData.moduleType)
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data.items;
                    invoiceContent.value = data;
                    contentId.value = data[0].id;
                    contentName.value = data[0].contentName;
                    getDetailById();
                }
                else {
                    Toast(res.message);
                }
            });
        };
        const blurCompanyNo = val => {
            if (val) {
                const status = isCompanyNo(val);
                if (!status) {
                    Toast('请输入有效的发票税号');
                    return;
                }
            }
        };
        const blurEmail = val => {
            const status = isEmail(val);
            if (!status) {
                Toast('请输入有效的邮箱');
                return;
            }
        };
        const blurBankNo = val => {
            const status = isBankCard(val);
            if (!status) {
                Toast('请输入有效的银行卡号');
                return;
            }
        };
        // const blurPhone = val => {
        //   const status = isMobile(val)
        //   if (!status) {
        //     Toast('请输入有效的手机号')
        //     return
        //   }
        // }
        const getList = () => {
            getInvoiceList({
                page: 1
            }).then((res) => {
                if (res.code === 200) {
                    invoiceList.value = res.data.items;
                    listTotal.value = res.data.total;
                }
            });
        };
        // /* 设置默认地址 */
        // const setDefault = val => {
        //   formData.isDefault = !formData.isDefault
        // }
        const submitForm = () => {
            // 在这里处理表单提交的逻辑
            console.log('提交表单');
        };
        /* 抬头类型选择 */
        const electronicHeader = type => {
            formData.invoiceTypePersonalCompany = type;
        };
        const descriptionBtn = () => {
            showDescription.value = !showDescription.value;
        };
        const slecetInvoiceBtn = () => {
            showModal.value = true;
        };
        const changeModel = () => {
            showModal.value = !showModal.value;
        };
        /* 发票类型选择 */
        const invoiceTypeSelect = val => {
            nowInvoiceType.value = val.type;
            nowInvoiceName.value = val.invoiceName;
            formData.invoiceType = val.type;
        };
        const contentSelectBtn = () => {
            showContent.value = true;
        };
        /* 发票内容选择 */
        const invoiceContentSelect = val => {
            contentId.value = val.id;
            contentName.value = val.contentName;
        };
        /* 一键录入 */
        const inputInvoice = () => {
            showInfo.value = true;
        };
        let loading = false; // 是否处于请求中
        /* 提交 */
        const submitApply = () => {
            if (loading) {
                Toast('加载中，请稍后');
                return;
            }
            const { moduleType, invoiceTitle, invoiceCode, invoiceEmail, companyBank, companyBankNo, companyAddr, companyPhone, templateId, addressId, isDefault, electronicInvoice, invoiceType, invoiceTypePersonalCompany } = formData;
            if (!invoiceTitle) {
                Toast('发票抬头不能为空');
                return;
            }
            if (invoiceTypePersonalCompany === 2) {
                if (invoiceCode) {
                    const status = isCompanyNo(invoiceCode);
                    if (!status) {
                        Toast('请输入有效的发票税号');
                        return;
                    }
                }
                else {
                    Toast('税号不能为空');
                    return;
                }
            }
            loading = true;
            let params = {
                orderId: orderId,
                moduleType,
                electronicInvoice,
                invoiceType,
                contentType: contentId.value,
                invoiceTypePersonalCompany: invoiceType === 1 ? 2 : invoiceTypePersonalCompany,
                invoiceTitle: invoiceTitle,
                invoiceCode: invoiceCode,
                invoiceEmail,
                companyBank,
                companyBankNo,
                companyAddr,
                companyPhone,
                templateId,
                addressId,
                isDefault
            };
            if (orderIds) {
                params.orderIds = orderIds;
            }
            applyInvoice(params)
                .then((res) => {
                if (res.code === 200) {
                    Toast('发票申请成功!');
                    location.href = `${hostPath}/learn/invoice/list`;
                }
                loading = false;
            })
                .catch(() => {
                loading = false;
            });
        };
        const recaptureData = data => {
            formData.invoiceTitle = data?.invoiceTitle;
            formData.invoiceCode = data?.companyNo;
            formData.invoiceEmail = data?.email;
            formData.companyBank = data?.companyBank;
            formData.companyBankNo = data?.companyBankNo;
            formData.companyPhone = data?.companyPhone;
            formData.companyAddr = data?.companyAddr;
            formData.isDefault = data?.isDefault;
            /* 回显发票抬头类型 */
            formData.invoiceTypePersonalCompany = data?.invoiceTypePersonalCompany || 1;
            /* 回显发票类型 */
            // const invoiceObject = invoiceTypeVal.find(
            // item => item.type === data?.invoiceType
            // )
            // formData.invoiceType = invoiceObject?.type || 2
            // nowInvoiceName.value = invoiceObject?.invoiceName || '普通发票'
            formData.templateId = data?.id || '0';
            /* 发票内容 */
            /*  invoiceContent.value.find(
              item => item.id === data?.invoiceType
            ) */
        };
        /* 发票模版数据查询 */
        const clickEntryData = id => {
            templateDetail({
                invoiceTemplateId: id
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    recaptureData(data);
                    /*  formData.invoiceTitle = data.invoiceTitle
                    formData.invoiceCode = data.companyNo
                    formData.invoiceEmail = data.email
                    formData.companyBank = data.companyBank
                    formData.companyBankNo = data.companyBankNo
                    formData.companyPhone = data.companyPhone
                    formData.companyAddr = data.companyAddr
              
                    formData.invoiceTypePersonalCompany = data.invoiceTypePersonalCompany /* 回显发票抬头类型 */
                    /* 回显发票类型 */
                    /*const invoiceObject = invoiceTypeVal.find(
                      item => item.type === data.invoiceType
                    )
                    console.log(invoiceObject, 'invoiceObject')
              
                    formData.invoiceType = invoiceObject?.type || 2
                    nowInvoiceName.value = invoiceObject?.invoiceName || '普通发票' */
                    Toast('录入成功!');
                    showInfo.value = false;
                }
            });
        };
        /* 根据用户ID获取默认发票模版数据 */
        const getDetailById = () => {
            $showLoading();
            detailByUserId().then((res) => {
                $hideLoading();
                if (res.code === 200) {
                    const data = res.data;
                    recaptureData(data);
                    /* formData.invoiceTitle = data.invoiceTitle
                    formData.invoiceCode = data.companyNo
                    formData.invoiceEmail = data.email
                    formData.companyBank = data.companyBank
                    formData.companyBankNo = data.companyBankNo
                    formData.companyPhone = data.companyPhone
                    formData.companyAddr = data.companyAddr
                    /* 回显发票类型 */
                    /* const invoiceObject = invoiceTypeVal.find(
                      item => item.type === data.invoiceType
                    )
                    console.log(invoiceObject, 'invoiceObject')
              
                    formData.invoiceType = invoiceObject?.type || 2
                    nowInvoiceName.value = invoiceObject?.invoiceName || '普通发票'
                    /* 回显发票抬头类型 */
                    /*  formData.invoiceTypePersonalCompany = data.invoiceTypePersonalCompany */
                }
            });
        };
        const copyCode = val => {
            let oInput = document.createElement('input');
            oInput.value = val;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand('Copy');
            oInput.remove();
            Toast('复制成功');
        };
        // 获取订单详情
        const getOrderDetail = () => {
            orderDetail({
                orderId: String(orderId),
                moduleType: String(formData.moduleType),
                orderIds: orderIds
            }).then((res) => {
                if (res.code === 200) {
                    orderData.value = res.data;
                }
            });
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            if (!isLogin) {
                userLogin();
                return;
            }
            if (orderIds) {
                orderList.value = orderIds.split(',');
            }
            getContent();
            getList();
            getOrderDetail();
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '发票申请'
                }, {
                    shareBtn: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "clickEntry",
                            onClick: _withModifiers(inputInvoice, ["stop"])
                        }, "选择抬头", 8, _hoisted_2)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (!_unref(orderIds))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (copyCode(_unref(orderId))), ["stop"]))
                                }, [
                                    _hoisted_6,
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(orderId)), 1),
                                    _hoisted_8
                                ]))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(orderList.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        onClick: _withModifiers(($event) => (copyCode(item)), ["stop"])
                                    }, [
                                        _createTextVNode(" 订单编号" + _toDisplayString(index + 1), 1),
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(item), 1),
                                        _hoisted_11
                                    ], 8, _hoisted_9));
                                }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, "￥" + _toDisplayString(orderData.value?.payPrice || 0), 1),
                            _createElementVNode("a", {
                                class: "unionIcon",
                                onClick: _withModifiers(descriptionBtn, ["stop"])
                            }, [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    onClick: _withModifiers(descriptionBtn, ["stop"]),
                                    alt: ""
                                }, null, 8, _hoisted_16)
                            ], 8, _hoisted_15)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", {
                            class: _normalizeClass(["electronicTab", { active: isElectronicInvoice.value }])
                        }, "电子发票", 2)
                    ]),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(submitForm, ["prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("div", {
                                    class: "contentText flex-align-center",
                                    onClick: _withModifiers(slecetInvoiceBtn, ["stop"])
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(nowInvoiceName.value), 1),
                                    _hoisted_24
                                ], 8, _hoisted_23)
                            ]),
                            _createElementVNode("div", {
                                class: "invoiceList flex-align-center",
                                onClick: contentSelectBtn
                            }, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("span", null, _toDisplayString(contentName.value), 1),
                                    _hoisted_27
                                ])
                            ]),
                            (_unref(formData).invoiceType === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("label", {
                                            class: "radio-container",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (electronicHeader(1)))
                                        }, [
                                            _hoisted_31,
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["checkmark", {
                                                        active: _unref(formData).invoiceTypePersonalCompany === 1
                                                    }])
                                            }, _hoisted_33, 2)
                                        ]),
                                        _createElementVNode("label", {
                                            class: "radio-container marginL-20",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (electronicHeader(2)))
                                        }, [
                                            _hoisted_34,
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["checkmark", {
                                                        active: _unref(formData).invoiceTypePersonalCompany === 2
                                                    }])
                                            }, _hoisted_36, 2)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _withDirectives(_createElementVNode("input", {
                                    id: "invoice-content",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(formData).invoiceTitle) = $event)),
                                    maxlength: "30",
                                    placeholder: "请输入公司名称",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(formData).invoiceTitle]
                                ])
                            ]),
                            (_unref(formData).invoiceTypePersonalCompany === 2 ||
                                _unref(formData).invoiceType === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _hoisted_40,
                                    _withDirectives(_createElementVNode("input", {
                                        id: "bank",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(formData).invoiceCode) = $event)),
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (blurCompanyNo(_unref(formData).invoiceCode))),
                                        maxlength: "20",
                                        placeholder: "请输入纳税人识别号"
                                    }, null, 544), [
                                        [_vModelText, _unref(formData).invoiceCode]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isElectronicInvoice.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _hoisted_42,
                                    _withDirectives(_createElementVNode("input", {
                                        id: "tax-number",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(formData).invoiceEmail) = $event)),
                                        onBlur: _cache[7] || (_cache[7] = ($event) => (blurEmail(_unref(formData).invoiceEmail))),
                                        placeholder: "用于接收电子发票",
                                        required: ""
                                    }, null, 544), [
                                        [_vModelText, _unref(formData).invoiceEmail]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(formData).invoiceTypePersonalCompany === 2 ||
                                _unref(formData).invoiceType === 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createElementVNode("div", _hoisted_43, [
                                        _hoisted_44,
                                        _withDirectives(_createElementVNode("input", {
                                            id: "bank",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(formData).companyBank) = $event)),
                                            placeholder: "选填"
                                        }, null, 512), [
                                            [_vModelText, _unref(formData).companyBank]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                        _hoisted_46,
                                        _withDirectives(_createElementVNode("input", {
                                            id: "bank",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(formData).companyBankNo) = $event)),
                                            onBlur: _cache[10] || (_cache[10] = ($event) => (blurBankNo(_unref(formData).companyBankNo))),
                                            placeholder: "选填"
                                        }, null, 544), [
                                            [_vModelText, _unref(formData).companyBankNo]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                        _hoisted_48,
                                        _withDirectives(_createElementVNode("input", {
                                            id: "address",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(formData).companyAddr) = $event)),
                                            placeholder: "选填"
                                        }, null, 512), [
                                            [_vModelText, _unref(formData).companyAddr]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                        _hoisted_50,
                                        _withDirectives(_createElementVNode("input", {
                                            id: "address",
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(formData).companyPhone) = $event)),
                                            placeholder: "选填"
                                        }, null, 512), [
                                            [_vModelText, _unref(formData).companyPhone]
                                        ])
                                    ])
                                ], 64))
                                : _createCommentVNode("", true)
                        ], 40, _hoisted_20)
                    ]),
                    (!isElectronicInvoice.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_router_link, { to: "/address/list" }, {
                                        default: _withCtx(() => [
                                            _hoisted_55,
                                            _hoisted_56
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "bottomContent",
                        onClick: _withModifiers(submitApply, ["stop"])
                    }, _hoisted_59, 8, _hoisted_57),
                    _withDirectives(_createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", { class: "instructionsContent" }, [
                            _hoisted_61,
                            _hoisted_62,
                            _hoisted_63,
                            _createElementVNode("button", {
                                class: "submitKnow",
                                type: "submit",
                                onClick: descriptionBtn
                            }, " 我知道了 ")
                        ])
                    ], 512), [
                        [_vShow, showDescription.value]
                    ]),
                    _createVNode(BottomDialog, {
                        showModal: showModal.value,
                        titleText: '发票类型选择',
                        onChangeModel: changeModel,
                        onCloseModel: _cache[13] || (_cache[13] = ($event) => (showModal.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_64, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(invoiceTypeVal, (val, key) => {
                                    return _createElementVNode("li", {
                                        class: "flex-align-center",
                                        key: key,
                                        onClick: ($event) => (invoiceTypeSelect(val))
                                    }, [
                                        _createElementVNode("label", _hoisted_66, _toDisplayString(val.invoiceName), 1),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["checkmark radioMark", { active: val.type === _unref(formData).invoiceType }])
                                        }, _hoisted_68, 2)
                                    ], 8, _hoisted_65);
                                }), 64))
                            ])
                        ]),
                        _: 1
                    }, 8, ["showModal"]),
                    _createVNode(BottomDialog, {
                        ref: (_value, _refs) => {
                            _refs['contentRef'] = _value;
                            contentRef.value = _value;
                        },
                        showModal: showContent.value,
                        titleText: '发票内容选择',
                        onCloseModel: _cache[14] || (_cache[14] = ($event) => (showContent.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_69, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceContent.value, (content, key) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex-align-center",
                                        key: key,
                                        onClick: ($event) => (invoiceContentSelect(content))
                                    }, [
                                        _createElementVNode("label", _hoisted_71, _toDisplayString(content.contentName), 1),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["checkmark radioMark", { active: content.id === contentId.value }])
                                        }, _hoisted_73, 2)
                                    ], 8, _hoisted_70));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    }, 8, ["showModal"]),
                    _createVNode(BottomDialog, {
                        ref: (_value, _refs) => {
                            _refs['inputRef'] = _value;
                        },
                        showModal: showInfo.value,
                        titleText: '选择抬头',
                        "btn-text": '添加新的抬头',
                        onCloseModel: _cache[15] || (_cache[15] = ($event) => (showInfo.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_74, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceList.value, (item, key) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex-align-center",
                                        key: key
                                    }, [
                                        _createElementVNode("div", {
                                            class: "typeLeft",
                                            onClick: _withModifiers(($event) => (clickEntryData(item.id)), ["stop"])
                                        }, [
                                            _createElementVNode("div", _hoisted_76, [
                                                _createElementVNode("span", null, _toDisplayString(item.invoiceTitle), 1),
                                                _withDirectives(_createElementVNode("span", _hoisted_77, "默认", 512), [
                                                    [_vShow, item.isDefault]
                                                ])
                                            ]),
                                            _createElementVNode("p", _hoisted_78, _toDisplayString(item.invoiceTypePersonalCompany === 1
                                                ? '个人抬头'
                                                : '企业抬头'), 1)
                                        ], 8, _hoisted_75),
                                        _createVNode(_component_router_link, {
                                            to: {
                                                name: 'invoiceEdit',
                                                query: {
                                                    invoiceTemplateId: item.id,
                                                    orderId: _unref(orderId),
                                                    type: _unref(orderType)
                                                }
                                            }
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_79
                                            ]),
                                            _: 2
                                        }, 1032, ["to"])
                                    ]));
                                }), 128))
                            ]),
                            (showInfo.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                    (invoiceList.value.length < 20)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: {
                                                name: 'invoiceAdd',
                                                query: { orderId: _unref(orderId), type: _unref(orderType) }
                                            }
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_81
                                            ]),
                                            _: 1
                                        }, 8, ["to"]))
                                        : (_openBlock(), _createElementBlock("button", _hoisted_82, " 列表已满，请编辑无用发票内容 "))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["showModal"])
                ])
            ]));
        };
    }
});
